// extracted by mini-css-extract-plugin
module.exports = {"separation":"headerSeparation_separation__2XB3p"};